import React from 'react'
import cn from 'classnames'
import styles from './app-store-button.module.scss'

interface AppStoreButtonProps {
  onClick?: () => void
  buttonImg: string
}

export const AppStoreButton: React.FC<AppStoreButtonProps> = (props) => {
  return (
    <button className={cn(styles.base, styles.appStoreBtn)} onClick={props.onClick} data-qa="btnStore">
      <img className={cn(styles.base, styles.appStoreBtn)} src={props.buttonImg} height={44} alt="App Store Download" />
    </button>
  )
}
